import React, { PropsWithChildren, useCallback, useMemo, useState } from 'react';
import styled from 'styled-components';
import Modal from './Modal';
import { PaneTitle } from './PaneTitle';
import ModalContext from './ModalContext';

const StyledModalContent = styled.div`
  position: relative;
  background-color: #FFFFFF;
  border: 1px solid #E2E7ED;
  border-radius: 2px;
  box-shadow: 0 0 30px 2px rgba(121, 133, 149, 0.50);
  background-clip: padding-box;
  outline: 0;
  padding: 0;
  font-size: 14px;
`;

type Props = {
    className?: string,
    badge?: string,
    size?: string,
    onClose: () => void,
    title?: JSX.Element | string,
    hidden?: boolean,
    blankMode?: boolean,
    forceTop?: boolean,
    closeOnBackdropClick?: boolean,
};

export function PaneModal({
	className,
	badge,
	size,
	onClose,
	title,
	hidden: initHidden = false,
	blankMode,
	forceTop,
	children,
	closeOnBackdropClick,
}: PropsWithChildren<Props>) {

	const [hidden, setHidden] = useState(initHidden);

	const onHide = useCallback(() => {
		setHidden(true);
	}, []);

	const onShow = useCallback(() => {
		setHidden(false);
	}, []);

	const context = useMemo(() => ({
		hide: onHide,
		show: onShow
	}), [onHide, onShow]);

	return <ModalContext.Provider value={context}>
		<Modal
			className={className}
			size={size}
			hidden={hidden}
			onClose={onClose}
			closeOnBackdropClick={closeOnBackdropClick}
			forceTop={forceTop}
		>
			<StyledModalContent className="modal-content">
				<PaneTitle
					blankMode={blankMode}
					onClose={onClose}
					badge={badge}
					title={title}
				/>
				{children}
			</StyledModalContent>
		</Modal>
	</ModalContext.Provider>;
}
